<template>
  <div>
    <div class="my-3">
      <em class="font-18 color-orange fa fa-info-circle mr-2" />
      <span class="color-black font-16 font-weight-bold">
        Información Adicional
      </span>
    </div>
    <div class="row">
      <div class="col">
        <div class="color-secondary-6 font-14">
          Servicio:
        </div>
        <span class="color-black font-16">
          {{ data.disciplineDescription }}
        </span>
      </div>
      <div v-if="isVisitType(data)" class="col">
        <div class="color-secondary-6 font-14">
          Modalidad:
        </div>
        <span class="color-black font-16">
          {{ data.modalityDescription | empty }}
        </span>
      </div>
      <div v-if="isVisitType(data)" class="col">
        <div class="color-secondary-6 font-14">
          Frecuencia:
        </div>
        <span class="color-black font-16">
          {{ data.frecuency | empty }}
        </span>
      </div>
      <div v-if="isVisitType(data)" class="col">
        <div class="color-secondary-6 font-14">
          Duración:
        </div>
        <span class="color-black font-16">
          {{ data.duration | empty }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import thrpyBillingTransactionType from '@/utils/constants/thrpyBillingTransactionType.js';
export default {
  name: 'AdditionalInfo',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isVisitType() {
      return (item) =>
        item.transactionType == thrpyBillingTransactionType.Visit;
    },
  },
};
</script>
